import { Link } from '@tanstack/react-router';
import { DeviceCheck } from './DeviceCheck';
import { NotificationsCard } from './NotificationsCard';
import { ReceivedList } from './ReceivedList';
import { SpikeGate } from './SpikeGate';

export function SpikePage() {
  return (
    <SpikeGate>
      {({ token, config, lock }) => (
        <div className="stack">
          <h1>iPhone test page</h1>
          <p className="version">Temporary tools for phase P01. Removed later.</p>
          <DeviceCheck />
          <NotificationsCard token={token} vapidPublicKey={config.vapidPublicKey} />
          <p>
            <Link to="/spike/shortcuts">Build the Shortcuts →</Link>
          </p>
          <ReceivedList token={token} />
          <p>
            <button type="button" onClick={lock}>
              Lock this page
            </button>
          </p>
        </div>
      )}
    </SpikeGate>
  );
}
